import { ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Tutorial } from '../../models/tutorial.model';
import { TutorialService } from '../../services/tutorial.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { AbstractControl, FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { TutorialItemListComponent } from '../tutorial-item-list/tutorial-item-list.component';

@Component({
  selector: 'app-admin-list',
  templateUrl: './tutorial-list.component.html',
  styleUrls: ['./tutorial-list.component.scss', './../../tutorial.scss']
})
export class TutorialListComponent extends BaseFormComponent<Tutorial[]> implements OnInit, OnDestroy {
  
  isAdmin:boolean = false;
  isOrdering:boolean = false;
  permission:boolean = null;

  data:Tutorial[];
  currentId: number;
  public modalRef: BsModalRef;

  @ViewChild('modal') modal: TemplateRef<any>;
  @ViewChild(TutorialItemListComponent) itemList: TutorialItemListComponent;
  
  constructor(
      private myService: TutorialService,
      public activatedRoute: ActivatedRoute,
      private modalService: BsModalService,
      private cdr: ChangeDetectorRef,
      private router: Router,
    ) {
      super(activatedRoute); 
    }
  
  ngOnInit() {
    this.loading();
    var type = this.activatedRoute.snapshot.data['userType'];
    this.permission = this.activatedRoute.snapshot.data['permission'];
    this.isAdmin = type == 'admin'? true: false;
  }

  ngAfterViewInit(): void{
    this.start();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

	start(): void {
		this.myService.list().subscribe({
      next: (res: Tutorial[]) => {
			  this.entity = res;
			  this.data = res;
        this.itemList.initForm(res);
        this.loaded();
      },
      error: (error) => {
        let msg = error?.error?.message || (error?.error?.match(/{"message":"(.+)"}/)?.[1]) || '';
        this.msgError(msg);
        this.loaded();
      },
    })
  }
  
  openModal(id:number = null): void {
    event.stopPropagation();
    this.currentId = id;
    this.modalRef = this.modalService.show(this.modal,{class:"modal-m"});
  }

  closeModal(): void {
    this.modalRef?.hide();
  }
  
  saveList(newData): void {
    this.loading();
    this.myService.updateList(newData).subscribe({
      next: (res) => {
        this.confirmation("Ordem alterada com sucesso!").subscribe(() => {
          window.location.reload();
        });
        this.loaded();
      },
      error: (error) => {
        let msg = error?.error?.message || (error?.error?.match(/{"message":"(.+)"}/)?.[1]) || '';
        this.msgError(msg);
        this.loaded();
      },
    });
  }

  deleteList(ids:number[]):void{
    console.log(ids)
    this.loading();
    this.myService.deleteList(ids).subscribe({
      next: (res) => {
        this.confirmation("Deletado com sucesso!").subscribe(() => {
          window.location.reload();
        });
        this.loaded();
      },
      error: (error) => {
        let msg = error?.error?.message || (error?.error?.match(/{"message":"(.+)"}/)?.[1]) || '';
        this.msgError(msg);
        this.loaded();
      },
    });
  }

  excluir(id: any): void {
    this.loading();
    this.myService.delete(id).subscribe({
      next: (res) => {
        this.confirmation("Deletado sucesso!").subscribe(() => {
          window.location.reload();
        });
        this.loaded();
      },
      error: (error) => {
        let msg = error?.error?.message || (error?.error?.match(/{"message":"(.+)"}/)?.[1]) || '';
        this.msgError(msg);
        this.loaded();
      }
    });
  }

  changeShow(event: { id: number; status: boolean }):void{
    this.loading();
    var newData = { actived: event.status};
    this.myService.update(newData, event.id).subscribe({
      next: (res) => {
        this.confirmation("Tutorial alterado com sucesso!").subscribe(() => {
          window.location.reload();
        })
        this.loaded();
      },
      error: (error) => {
        let msg = error?.error?.message || (error?.error?.match(/{"message":"(.+)"}/)?.[1]) || '';
        this.msgError(msg);
        this.loaded();
      },
    })
  }
  
  
  openTutorial(id:number):void {
    var type = this.isAdmin == true? 'admin': 'user';
    this.router.navigate(['tutorial/' + type + '/' + id]);
  }

  changeStatusAdmin(){
    var type = this.isAdmin == true? 'admin': 'user';
    console.log(this.isAdmin)
    history.pushState({}, '', 'tutorial/' + type + '/pesquisa-geral');
    //this.router.navigate(['tutorial/' + type ]);
  }

}
